import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "form-links"
}
const _hoisted_5 = {
  key: 1,
  class: "form-links"
}

import AppActivity from "@/components/AppActivity.vue";

import {ICON_CANCEL, ICON_MAIL, ICON_OK, ICON_UNDO} from "@/lib/icons";
import {useRouter} from "vue-router";
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import LoginPasswordChangeModal from "@/components/login/LoginPasswordChangeModal.vue";
import {useApiClient} from "@/api";
import {hideSpinner, showAlert, showConfirm, showSpinner} from "@/store";
import Configuration from "@/api/types/Configuration";
import GdprText from "@/components/login/GdprText.vue";
import GdprCheckbox from "@/components/login/GdprCheckbox.vue";
import LoginPasswordForgotModal from "@/components/login/LoginPasswordForgotModal.vue";
import ChangePasswordRequest from "@/api/requests/ChangePasswordRequest";
import ProfileDeletionModal from "@/components/login/ProfileDeletionModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginActivity',
  setup(__props) {

const store = useStore()
const router = useRouter()
const apiClient = useApiClient()

const username = ref<string>('')
const password = ref<string>('')
const gdprChecked = ref<boolean>(false)
const showPasswordChange = ref<boolean>(false)
const showPasswordForgot = ref<boolean>(false)
const showProfileDeletion = ref<boolean>(false)

const waitingForResetConfirmation = ref<boolean>(false)

const updateIcons = () => {
  const newIcons = []

  if (store.state.configuration) {
    newIcons.push(ICON_MAIL)
    newIcons.push(ICON_UNDO)
  } else {
    newIcons.push(ICON_OK)
  }

  newIcons.push(ICON_CANCEL)

  return newIcons
}

const icons = ref<string[]>([])

watch(() => store.state.configuration, () => {
  username.value = store.state.configuration?.username || null
  password.value = store.state.configuration?.password || null
  gdprChecked.value = (!! store.state.configuration?.sessionId) || false

  icons.value = updateIcons()
}, { immediate: true })

const onSubmit = async () => {
  showSpinner()

  try {
    const response = await apiClient.login(username.value, password.value)

    store.commit('SET_CONFIGURATION', {
      sessionId: response.sessionId,
      username: username.value,
      password: password.value,
      user: response.user,
      lastLogin: new Date()
    } as Configuration)

    await router.push({ name: 'menu' })
  } catch (err: any) {
    console.error(err)
    showAlert('Fehler: ' + err.message, 'Interner Fehler')
  }

  hideSpinner()
}

const onAction = (icon: string) => {
  switch (icon) {
    case ICON_OK:
      if (!username.value.length) {
        showAlert('Sie müssen einen gültigen Benutzernamen eingeben!')
      }
      else if (!password.value.length) {
        showAlert('Sie müssen ein gültiges Passwort eingeben!')
      }
      else if (!gdprChecked.value) {
        showAlert('Sie müssen die Datenschutzrichtlinien akzeptieren um die Anwendung benutzen zu dürfen!')
      }
      else {
        onSubmit()
      }
      break
    case ICON_UNDO:
      waitingForResetConfirmation.value = true
      showConfirm("Sollen die lokalen Daten wirklich unwiederruflich gelöscht werden?", "Lokale Daten löschen")
      break
    case ICON_CANCEL:
      if (store.state.configuration) {
        router.push({ name: 'menu' })
      } else {
        router.push({ name: 'home' })
      }
      break
  }
  console.log('action', icon)
}

watch(() => store.state.alert.lastResult, async (result) => {
  if (result && waitingForResetConfirmation.value) {
    waitingForResetConfirmation.value = false

    showSpinner()
    if (await store.dispatch('RESET_LOCAL_DATA')) {
      showAlert('Die App wurde erfolgreich zurückgesetzt.')
    } else {
      showAlert('Beim Zurücksetzen der App ist ein unerwarteter Fehler aufgetreten')
    }

    hideSpinner()

  }
})

const onPasswordChange = async ({ oldPassword, newPassword }: { oldPassword: string, newPassword: string }) => {
  showSpinner()
  showPasswordChange.value = false

  const api = useApiClient()
  try {
    const res = await api.changePassword(
        store.state.configuration?.sessionId,
        new ChangePasswordRequest(store.state.configuration?.user.username, oldPassword, newPassword))
    console.log('RES', res)
    showPasswordChange.value = false
    hideSpinner()
    await showAlert('Ihr Passwort wurde erfolgreich geändert!')
  } catch (e: any) {
    hideSpinner()
    await showAlert(e.message)
  }
}

const onPasswordForgot = async (email: string) => {
  showSpinner()
  showPasswordChange.value = false

  const api = useApiClient()

  try {
    await api.getNewPassword(email)
    showPasswordForgot.value = false
    hideSpinner()
    await showAlert('Die Passwort - Anfrage wurde erfolgreich übermittelt. Sie erhalten die Zugangsdaten per E-Mail.')
  } catch (e: any) {
    hideSpinner()
    await showAlert(e.message)
  }
}

const onProfileDeletion = async () => {
  showSpinner()
  showProfileDeletion.value = false

  const configuration = store.state.configuration

  await store.dispatch('RESET_LOCAL_DATA')

  const api = useApiClient()
  try {
    await api.deleteUser(configuration.value.user)
    showPasswordForgot.value = false
    hideSpinner()
    await showAlert('Ihr Zugang wurde erfolgreich gelöscht.')
  } catch (e: any) {
    hideSpinner()
    await showAlert(e.message)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    icons: icons.value,
    onIconClick: onAction
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form login-form",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createElementVNode("label", null, [
          _createTextVNode(" Benutzername "),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
            disabled: _unref(store).state.configuration
          }, null, 8, _hoisted_2), [
            [_vModelText, username.value]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Passwort "),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            disabled: _unref(store).state.configuration
          }, null, 8, _hoisted_3), [
            [_vModelText, password.value]
          ])
        ]),
        (!_unref(store).state.configuration)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'signup' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("Registrieren …")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[2] || (_cache[2] = () => showPasswordForgot.value = true)
                }, "Passwort vergessen …")
              ])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[3] || (_cache[3] = () => showPasswordChange.value = true)
                }, "Passwort ändern …")
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'profile' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("Profil …")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[4] || (_cache[4] = () => onAction(<string>_unref(ICON_UNDO)))
                }, "Abmelden …")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[5] || (_cache[5] = () => showProfileDeletion.value = true)
                }, "Zugang löschen")
              ])
            ])),
        _createVNode(GdprText)
      ], 40, _hoisted_1),
      _createVNode(LoginPasswordChangeModal, {
        show: showPasswordChange.value,
        onOk: onPasswordChange,
        onCancel: _cache[6] || (_cache[6] = () => showPasswordChange.value = false)
      }, null, 8, ["show"]),
      _createVNode(LoginPasswordForgotModal, {
        show: showPasswordForgot.value,
        onOk: onPasswordForgot,
        onCancel: _cache[7] || (_cache[7] = () => showPasswordForgot.value = false)
      }, null, 8, ["show"]),
      _createVNode(ProfileDeletionModal, {
        show: showProfileDeletion.value,
        onOk: onProfileDeletion,
        onCancel: _cache[8] || (_cache[8] = () => showProfileDeletion.value = false)
      }, null, 8, ["show"]),
      _createVNode(GdprCheckbox, {
        modelValue: gdprChecked.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((gdprChecked).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["icons"]))
}
}

})